import React, { useCallback, useRef, useState, useEffect } from 'react';
import { Box, IconButton, styled, Typography, useMediaQuery } from '@material-ui/core';
import { PaymentStatusBadge } from '../components/paymentStatusBadge.component';
import { useReservation } from './reservation.context';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import { httpDelete, put } from '../../fetch';
import { useDomainPath, useAuth, useAuthUsers } from '../../auth/auth.context';
import { useHistory } from 'react-router-dom';
import { AlertDialog } from '../../components/alerts/AlertDialog.component';
import { isAdmin } from '../../auth/roles';
import { BaseCSSProperties } from '@material-ui/core/styles/withStyles';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';
import { useAlerts } from '../../hooks/useAlerts';

const useStyles = makeStyles((theme: Theme) => ({
  mediumIcon: {
    fontSize: '1.8rem !important',
  },
  backButton: {
    [theme.breakpoints.down('sm')]: {
      marginLeft: "45px",
    },
  }
}));

export const UpdateToolbar: React.FC = () => {
  const { reservation } = useReservation();
  const reservationPath = useDomainPath('/reservation');
  const history = useHistory();
  const { loggedUser } = useAuthUsers();
  const isReservationActive = reservation.active !== undefined && reservation.active !== 1 ? 0 : 1;
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const auth = useAuth();
  const ref:any = useRef(null);
  const [width, setWidth] = useState(0);
  const classes = useStyles();
  const { notify } = useAlerts();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  useEffect(() => {
    const stored = localStorage.getItem('notifyRestauredReservation');
    if(stored !== null) {
      notify(`La réservation a été restaurée`, 'success');
      localStorage.removeItem('notifyRestauredReservation');
    }
  },[notify]);

  useEffect(() => {
    setWidth(ref?.current?.offsetWidth);
  },[ref?.current?.offsetWidth]);

  const Offset = styled('div')(({ theme }) => ({
    ...(theme.mixins.toolbar as BaseCSSProperties),
  }));

  const deleteReservationDialog = useCallback(() => setDeleteDialogOpen(true), [
    setDeleteDialogOpen,
  ]);
  const deleteReservationDialogClose = useCallback(
    () => setDeleteDialogOpen(false),
    [setDeleteDialogOpen],
  );

  const deleteReservation = useCallback(
    () =>
      httpDelete(`${reservationPath}/${reservation._id}`).then(() =>
        history.push(`/reservations/futur`),
      ),
    [history, reservationPath, reservation._id],
  );

  const goBack = useCallback((e) => {
    e.preventDefault();
    history.goBack();
  }, [history]);

  const deleteReservationSoft = useCallback(
    async () => {
      reservation.active = 0;
      reservation.deletedDate = new Date();
      reservation.deletedByUser = loggedUser?.displayName;
      try {
        await put<Partial<CRM.CreateReservation>>(
          `${reservationPath}/${reservation._id}`,
          reservation,
        ).then(() => {history.goBack()})

      } catch (err) {
        throw err;
      }
    },
    [reservationPath, reservation, loggedUser, history],
  );

  const restoreReservation = useCallback(
    async () => {
      reservation.active = 1;
      reservation.deletedDate = undefined;
      reservation.deletedByUser = "";
      try {
        await put<Partial<CRM.CreateReservation>>(
          `${reservationPath}/${reservation._id}`,
          reservation,
        );
        localStorage.setItem('notifyRestauredReservation', 'true');
        window.location.reload();
      } catch (err) {
        throw err;
      }
    },
    [reservationPath, reservation],
  );


  return (
    <div ref={ref} >
    <Box position={'fixed'} style={{width:width, top:'0', backgroundColor:'white', zIndex: 9}} >
      <Box display={'flex'} style={{marginBottom: isMobile ? '0.5rem' : '1rem', marginTop:'1rem'}} justifyContent={'space-between'}>
      <Box display={'flex'} alignItems={!isMobile ? 'baseline' : 'center'} >
        <IconButton className={classes.backButton} onClick={goBack} size={'small'} title={'retourner à la liste'} color={'secondary'}>
          <ArrowBackIosIcon/>
        </IconButton>
              {(reservation && reservation._id) && isAdmin(auth.userGroup) && <IconButton
                title={!isReservationActive ? 'supprimer définitivement' : 'supprimer'}
                onClick={deleteReservationDialog}
              >
                <DeleteIcon className={classes.mediumIcon} />
              </IconButton>}
              {(reservation && reservation._id) && (!isAdmin(auth.userGroup) && isReservationActive === 1) && <IconButton
                title={'supprimer'}
                onClick={deleteReservationDialog}
                className={classes.mediumIcon}
              >
                <DeleteIcon className={classes.mediumIcon} />
              </IconButton>}
              <AlertDialog
                accept={!isReservationActive ? deleteReservation : deleteReservationSoft}
                cancel={deleteReservationDialogClose}
                open={deleteDialogOpen}
                title={'Confirmer'}
                content={
                  !isReservationActive ? "La suppression d'une réservation est irréversible, voulez-vous vraiment continuer ?" :
                    "Cette réservation ira dans la corbeille, voulez-vous vraiment continuer ?"
                }
              />
              {(reservation && reservation._id) && !isReservationActive && <IconButton
                title={'restaurer'}
                size={'small'}
                onClick={restoreReservation}
              >
                <RestoreFromTrashIcon className={classes.mediumIcon} />
              </IconButton>}
              &nbsp;
              {(reservation && reservation._id) && (<Typography variant={isMobile ? "subtitle1" : "h4"}>
                {reservation.customer?.name || '...'}{' '}
                {reservation.customer?.firstname || '...'}
                {!isReservationActive ? ' ( dans la corbeille )' : ''}
              </Typography>)}
              
              {!isMobile && (reservation && reservation._id) && (<Box ml={2}>
                <Typography variant="body1">
                  n° {String(reservation.refNumber).padStart(6, '0')}
                </Typography>
              </Box>)}
              {!isMobile && (reservation && reservation._id) && reservation.bookingId && (
                <Box ml={2}>
                  <Typography variant="body2">
                    <i>(Résa web n° {reservation.bookingId})</i>
                  </Typography>
                </Box>
              )}

              {isMobile && (reservation && reservation._id) && (<Box ml={1}>
                <Typography variant="body1" style={{whiteSpace:"nowrap"}}>
                  n° {String(reservation.refNumber).padStart(6, '0')}
                </Typography>
                { !reservation.bookingId && (
                  <Typography variant="body1" style={{whiteSpace:"nowrap", marginBottom:"0.5em"}}>
                    <i>(@ n° {reservation.bookingId})</i>
                  </Typography>
                )}
                {reservation.payment && <PaymentStatusBadge payment={reservation.payment} />}
              </Box>)}

      </Box>
      {(reservation && reservation._id) && reservation.payment && !isMobile && (
        <PaymentStatusBadge payment={reservation.payment} />
      )}
    </Box>
  </Box>
  <Offset />
  </div>
  );
};
